import React, { ReactElement, useEffect } from 'react';
import { useUserHasRole } from '@/lib/auth/useUserHasRoles';
import { Role } from '@/lib/auth/roles/role.enum';
import { Layout, Spinner } from 'elmo-elements';
import ThemeComponent from './components/SettingsTheme';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import SettingsHeader from './components/Header';
import SettingsBaseRoutes, {
  SettingsParamTypes,
  TenantSettingsTabs,
} from './SettingRoutes';
import MyLibraryRoutes from '../MyLibrary/MyLibraryRoutes';
import PublishingComponent from './components/SettingsPublishing';
import CategoriesComponent from './components/SettingsCategories';
import TemplatesComponent from './components/SettingsTemplate';
import { useFlags } from 'launchdarkly-react-client-sdk';
import CategoriesComponentV2 from '@/pages/Settings/components/SettingsCategoriesV2';

const RenderActiveTab = (currentTab: string) => {
  const { learningElaNewCourseLibraryEnable: isTenantCategoryV2Enabled } =
    useFlags();

  switch (currentTab) {
    case TenantSettingsTabs.Publishing:
      return <PublishingComponent />;
    case TenantSettingsTabs.Categories:
      if (isTenantCategoryV2Enabled === undefined) return <Spinner />;

      return isTenantCategoryV2Enabled ? (
        <CategoriesComponentV2 />
      ) : (
        <CategoriesComponent />
      );
    case TenantSettingsTabs.Theme:
      return <ThemeComponent />;
    case TenantSettingsTabs.Template:
      return <TemplatesComponent />;

    default:
      return <PublishingComponent />;
  }
};

const Settings = (): ReactElement => {
  const history = useHistory();
  const isCompanyAdmin = useUserHasRole([Role.CAdmin]);
  const validTabs = isCompanyAdmin
    ? [TenantSettingsTabs.Theme]
    : [
        TenantSettingsTabs.Publishing,
        TenantSettingsTabs.Categories,
        TenantSettingsTabs.Theme,
        TenantSettingsTabs.Template,
      ];
  const { tabSelected } = useParams<SettingsParamTypes>();
  const hasAdminRole = useUserHasRole([
    Role.Admin,
    Role.Super,
    Role.Migration,
    Role.CAdmin,
  ]);

  useEffect(() => {
    if (validTabs.includes(tabSelected as TenantSettingsTabs)) return;

    history.replace(
      generatePath(SettingsBaseRoutes.path, {
        tabSelected: TenantSettingsTabs.Publishing,
      }),
    );
  }, [tabSelected]);

  if (hasAdminRole !== undefined && !hasAdminRole) {
    history.replace(generatePath(MyLibraryRoutes.path));
  }

  return (
    <>
      <Layout.Header>
        <SettingsHeader />
      </Layout.Header>
      <div className="editor-layout__body">
        <Layout.Content>{RenderActiveTab(tabSelected)}</Layout.Content>
      </div>
    </>
  );
};
export default Settings;
